export const manualName = {
  CAMERAS: 'cameras',
  NAME_ERRORS: 'nameErrors',
  USERS: 'users',
  ZONES: 'zones',
  ROLES: 'roles',
  REPORTS: 'reports'
}
